<style lang="scss" scoped>
</style>
<style lang="scss">
.el-main {
  padding: 0; // 可以写多个style标签，不加scoped就可以当作全局的使用
}
.backHomeModal {
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  top: 0;
  left: 0;
}
.backHomeInfo {
  background-color: #fff;
  border-radius: 20px;
  width: 400px;
  height: 300px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.questionDialog{
  // .el-dialog__body {
  //  *{
  //     max-width: 100%;
  //   }
  // }
  .htmlDialog *{
    max-width: 100%;
  }
  .htmlDialog {
    img,video {
      max-width: 100%;
    }
  }
}

.scratch-loading {
    position: absolute;
    top: 200px;
    left: 10%;
    width: 80%;
}

.progress {
    height: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
}
.progress-bar{
  background-color: lightblue;
  height: 20px;
}
.el-dialog__footer {
  text-align: center;
}
</style>
<template>
  <div>
      <div class="progress scratch-loading">
        <div class="progress-bar progress-bar-striped" role="progressbar"
              aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
              style="width: 0%; min-width: 7em;">
    <span>正在加载<span class="percent">5</span>%
    </span>
        </div>
    </div>
    <object
      type="application/x-shockwave-flash"
      data="/scratch/Code.swf"
      width="100%"
      height="850"
      id="scratch"
      style="visibility: visible;"
    >
      <param name="allowScriptAccess" value="always" />
      <param name="allowFullScreen" value="true" />
      <param name="wmode" value="opaque" />
      <param name="flashvars" :value="siteConfig" />
    </object>
    <div class="backHomeModal" v-if="showHomeModal">
      <div class="backHomeInfo">
        <p v-if="!isMock">{{customText}}，{{jumpTimeRemain}}后将自动关闭本页面。</p>
        <p v-else>{{customText}}，{{jumpTimeRemain}}后将自动关闭本页面。</p>
      </div>
    </div>
    <el-dialog
      class="questionDialog"
      title="题干"
      :visible.sync="questionVisible"
      width="50%"
      >
      <div class=" ql-container">
        <div class="ql-snow">
          <div class="htmlDialog ql-editor" v-html="currentQuestion.question_title">
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="questionVisible = false">取 消</el-button>
        <el-button type="primary" @click="questionVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <base-warn :warnContent="warnData.text" :warnCount="warnData.count" :showWarn.sync="showWarn" :warnType="warnData.type"></base-warn>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { getMockQuestionByCate } from '@/services/getData';
import BaseWarn from '../../../components/BaseWarn.vue';
import enableElectron from '../../../mixins/enableElectron';
//  value='site_config={"sitePrefix":"/","assetPrefix":"/","assetCdnPrefix":"./","internalAPI":"./scratch/","staticFiles":"./scratch/"}'
const baseUrl = process.env.BASE_URL;
const apiHost = process.env.VUE_APP_API_URL;
const cdnPrefix = process.env.VUE_APP_CDN;
export default {
  componentName: 'ExamMineCraft',
  mixins: [enableElectron],
  data() {
    return {
      scripts: {
        jquery: `${baseUrl}scratch/jquery-1.9.1.min.js`,
        scratchExt: `${baseUrl}scratch/scratch_ext.js`,
        scratch: `${baseUrl}scratch/scratch.js`,
      },
      scriptDom: {},
      scratchMc: `${baseUrl}scratch/mcpi-scratch.js`,
      opener: null,
      // siteConfig: `site_config={"sitePrefix":"${apiHost}","assetPrefix":"/","assetCdnPrefix":"./","internalAPI":"${'/api/save_mc/'}","staticFiles":"./scratch/"}`,
      // siteConfig: `site_config={"sitePrefix":"https://www.dev.codepku.com/","assetPrefix":"/",
      //                           "assetCdnPrefix":"//cdn.codepku.com/","projectPrefix":"scratch/project/","internalAPI":"scratch/","staticFiles":"scratch/"}`,
      siteConfig: `site_config={"sitePrefix":"${apiHost}/api/","assetPrefix":"/","assetCdnPrefix":"${cdnPrefix}/bluebridge/material/","projectPrefix":"${
        this.$route.query.answer_id
          ? 'examinee/answer/minecraft/project/'
          : 'examination-paper/question/code-json/'
      }","internalAPI":"scratch/","staticFiles":"scratch/"}`,
      // internalAPI 配置了接口（保存），设置资源（cdn）请求
      // staticFiles 配置了此项目根目录下用于放置scratch静态资源的目录
      //assetCdnPrefix 配置了请求资源用的cdn路径，不加protocol就和当前一致
      // sitePrefix可以用来配置api请求的host
      // projectPrefix配置的是请求项目的url
      scriptReady: false,
      mcReady: false,
      jumpTimeRemain: 3,
      showHomeModal: false,
      isMock: parseInt(this.$route.query.mock, 10) === 1,
      key: this.$route.query.key,
      mainKey: this.$route.query.mainkey,
      category: this.$route.query.category,
      currentQuestion: {}, //当前的题目
      questionVisible: false,
      customText: '', // 自定义那个弹框展示的内容
      percentage: 0,
      warnData: {}, //接受postmessage传来的data
      showWarn: false,
    };
  },
  methods: {
    loadScript(url) {
      const myScript = document.createElement('script');
      myScript.src = url;
      myScript.type = 'text/javascript';
      document.head.appendChild(myScript);
      return new Promise((resolve) => {
        myScript.onload = resolve;
      });
    },
    removeScript(myScript) {
      if (myScript) {
        document.head.removeChild(myScript);
      }
    },
    onBlurHandler() {
      if (this.opener) {
        this.opener.postMessage({
          event: 'BLUR',
        });
      }
    },
    onFocusHandler() {
      if (this.opener) {
        this.opener.postMessage({
          event: 'FOCUS',
        });
      }
    },
    onMessageHandler(e) {
      // console.log('');
      switch (e.data.event) {
        case 'QUESTION':
            console.log('收到了问题message', e.data.data);
          break;
        case 'EXAM_END':
          this.setAutoRedirect('试卷已提交');
          break;
        case 'MANUAL_CLOSE':
          window.close();
          break;
        case 'WARNING':
          console.log(e.data);
          this.warnData = e.data;
          this.showWarn = true;
          break;
        default:
          break;
      }
    },
    onUnloadHandler() {
      if (this.opener) {
        this.opener.postMessage({
          event: 'CLOSED',
        });
      }
    },
    onLoadedHandler() {
      console.log('domcontentloaded opener');
      if (this.opener) {
        this.opener.postMessage({
          event: 'LOADED',
        });
      }
    },
    fetchMockQuestion() {
      getMockQuestionByCate(this.category).then((resp) => {
        const question = resp.content.major_problems[this.mainKey].questions[this.key];
        this.currentQuestion = question;
      }).catch((err) => {
        console.log(err);
      });
    },
    setAutoRedirect(customText) {
        this.customText = customText;
        // this.$nextTick(() => { // 让展示的内容先更新
          const { opener } = window;
        this.showHomeModal = true;
        let timer = setInterval(() => {
          if (this.jumpTimeRemain > 0) {
            this.jumpTimeRemain -= 1;
          } else if (timer) {
            clearInterval(timer);
            timer = null;
            window.close();
            if (opener) opener.focus();
          }
        }, 1000);
        // });
    },
  },
  components: {
    BaseWarn,
  },
  created() {
    const {
      question_id,
      examination_id,
      answer_time,
      type,
      category,
      answer_id,
      precode,
    } = this.$route.query;
    const { opener } = window;
    if (this.isMock) {
      this.fetchMockQuestion();//模拟题需要另取
    }
    window.projectSaved = (data) => {
      console.log(data, '保存了');
      const examinee_answer = JSON.parse(data);
      if (!this.isMock) {
        if (opener) {
          opener.postMessage({
            event: 'SUBMIT',
            data: {
              qid: question_id,
              examinee_answer, // 如果是第一次保存，需要再告诉考试页面再获取一次数据
            },
            type: 'mc',
          });
        }
        this.$message.success('保存成功，即将关闭页面并回到考试页面。');
        this.setAutoRedirect('保存作品成功');
      }
    };
    window.saveProject = (data) => {
      console.log(data, opener);
      if (this.isMock) {
        //TODO:需要请求一下
        if (opener) {
          console.log(opener);
          //TODO:这里需要请求一下接口，返回成功再发送成功消息。
          opener.postMessage({
            event: 'WORK_SAVED',
            data: {
              key: this.key,
              mainKey: this.mainKey,
            },
          });
          this.$message.success('模拟考试已完成，即将关闭页面。');
          this.setAutoRedirect('保存作品成功');
        }
      }
    };
    const { token } = this.authority;
    window.MCPI_SERVER_URL = 'https://local.codepku.com:4715';
    const that = this;
    window.JSeditorReady = () => {
      const Scratch = document.getElementById('scratch');
      const from = {
        question_id,
        examination_id,
        answer_time,
        type,
        answer: 'minecraft',
        token,
      };
      // {
      //   question_id:0, //模拟题
      //   token
      // }
      Scratch.ASsetFrom(JSON.stringify(from)); //设置来源为 scratch  才能显示  回到作品页面 这个按钮
      Scratch.ASsetSavedCallback('projectSaved'); // 设置保存成功后的回调
      Scratch.ASsetBeforeSaveCallback('saveProject'); // 设置保存前的回调
      Scratch.ASsetEditMode(1);
      Scratch.ASsetLibVersion('20160719'); //设置库版本，强制客户端刷新
      console.log('JSeditorReady');
      if (answer_id && precode === '1') {
        Scratch.ASloadBaseProject(answer_id, 'minecraftproject'); // 预加载代码的方法
      } else if (precode === '1') {
        Scratch.ASloadBaseProject(question_id, 'minecraftproject'); // 预加载代码的方法
      }
      // window.onbeforeunload = (e) => {
      //   const saveNeeded = Scratch.AScheckSaveNeeded();
      //   if (saveNeeded) {
      //     const e = e || window.event;
      //     if (e) {
      //       e.returnValue = '离开此页后未保存的内容将会丢失';
      //     }
      //     return '离开此页后为保存的内容将会丢失';
      //   }
      // };
      that.mcReady = true;
      return true;
    };
    this.opener = opener;
    window.addEventListener('blur', this.onBlurHandler);
    window.addEventListener('focus', this.onFocusHandler);
    window.addEventListener('message', this.onMessageHandler);
    window.addEventListener('beforeunload', this.onUnloadHandler);
    window.addEventListener('load', this.onLoadedHandler);
    this.$on('show-question', () => {
      console.log('show-question');
      this.questionVisible = true;
    });
  },
  async mounted() {
    await this.loadScript(this.scripts.jquery);
    await this.loadScript(this.scripts.scratchExt);
    await this.loadScript(this.scripts.scratch);
    console.log('script ready now');
    this.scriptReady = true;
  },
  beforeDestroy() {
    this.removeScript();
    window.removeEventListener('blur', this.onBlurHandler);
    window.removeEventListener('focus', this.onFocusHandler);
    window.removeEventListener('message', this.onMessageHandler);
    window.removeEventListener('beforeunload', this.onUnloadHandler);
  },
  computed: {
    ...mapState({
      authority: 'authority',
      examPaper: 'examPaper',
    }),
    allReady() {
      return this.scriptReady && this.mcReady;
    },
  },
  props: {},
  watch: {
    allReady() {
      setTimeout(() => {
        console.log('load extension now');
        window.ScratchExtensions.loadExternalJS(this.scratchMc);
      }, 3000);
    },
    examPaper(val) {
      if (val && JSON.stringify(val) !== '{}' && !this.isMock) {
        const  questions  = val.major_problems[this.mainKey].questions.sort((a, b) => a.sort - b.sort);
        this.currentQuestion = questions[this.key];
      }
    },
  },
};
</script>
